.sn-step-guide-type-2 {
  display: flex;
  flex-direction: column;
  gap: map-get($spacings, 2xl);

  @include above($breakpoint-desktop-md) {
    gap: map-get($spacings, 3xl);
  }

  &__header {
    display: flex;
    flex-direction: column;
    margin-bottom: map-get($spacings, 2xl);

    @include above($breakpoint-desktop-md) {
      margin-bottom: map-get($spacings, 3xl);
    }

    .me-text {
      @include above($breakpoint-desktop-md) {
        max-width: calc(100% * 8 / 12);
      }
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      grid-template-columns: repeat(2, 1fr);

      // Fill column-by-column (6 fixed items → left column 1-3, right column 4-6)
      // instead of the default row-wise flow (1 left, 2 right, 3 left…).
      grid-template-rows: repeat(3, auto);
      grid-auto-flow: column;
      gap: map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      gap: map-get($spacings, 2xl);
    }
  }

  &__step {
    display: flex;
    align-items: flex-start;
    gap: map-get($spacings, md);
  }

  &__number {
    display: flex;
    align-items: center;
    justify-content: center;

    @include size(32px);

    background-color: var(--color-brand-primary-lightest);
    color: var(--color-brand-primary-main);
    font-family: Graphik, Arial, sans-serif;
    font-weight: 700;
    font-size: map-get($font-sizes, md);
    flex-shrink: 0;
  }

  &__step-content {
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--text-color-primary);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }

    strong {
      font-weight: 700;
    }
  }

  // Step title rendered as <me-heading tag="h4"> for SEO, kept inline with the
  // following text and matching the surrounding body sizing.
  &__step-title {
    display: inline;
    font-weight: 700;

    h4,
    .me-heading {
      display: inline;
      font: inherit;
      color: inherit;
      margin: 0;
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
